import React from 'react';
import ReactDOM from 'react-dom/client';

import ErrorBoundary from '@/components/ErrorBoundary';
import { APP_FAVICON_URL, THEME_COLOR } from '@/config/appConfig';
import { applyThemeColor } from '@/store/personalization';
import { setPageTitle } from '@/utils/dom';

import App from './App';

import '@/styles/index.scss';
import 'streamdown/styles.css';

applyThemeColor(THEME_COLOR);

setPageTitle('');
document
  .querySelectorAll<HTMLLinkElement>(
    'link[rel="icon"], link[rel="apple-touch-icon"]'
  )
  .forEach((link) => {
    link.href = APP_FAVICON_URL;
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
